import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {

  constructor() {
  }

  clear(): void {
    localStorage.clear();
  }

  setItem(key: string, data: string): void {
    localStorage.setItem(key, data);
  }

  getItem(key: string): string {
    return localStorage.getItem(key);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
